import React from 'react';
import HospitalForm from './HospitalForm';
import { useNavigate, useParams } from 'react-router-dom';
import ContactForm from '../school/ContactForm';
import useUpload from 'hooks/useUpload';
import paths from 'routes/paths';
import { useHospital, useUpdateHospital } from 'hooks/useBeneficiaries';

function EditHospital() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();

  const { hospital } = useHospital(id);
  const { updateHospitalAsync, isUpdating } = useUpdateHospital();

  // TODO: Contact data and mutations need to be migrated to Supabase
  const contactData = null;
  const updateContactLoading = false;
  const insertContactLoading = false;

  const submitEditHospital = async data => {
    try {
      if (data.hospital_document && typeof data.hospital_document !== 'string') {
        const hospital_document = await upload(data.hospital_document);
        data.hospital_document = hospital_document;
      }

      const hospitalData = {
        ...data,
        name: data.hospitalName,
        phone: data.contact,
        document: data.hospital_document
      };

      await updateHospitalAsync({ id, data: hospitalData });
      navigate(paths.hospital);
    } catch (error) {
      console.error('Error updating hospital:', error);
    }
  };

  const submitContact = values => {
    // TODO: Implement contact update/create when migrated to Supabase
    console.log('Contact submission not yet implemented for Supabase', values);
  };

  return (
    <>
      <HospitalForm
        onSubmit={submitEditHospital}
        loading={isUpdating || uploadLoading}
        initValues={hospital || {}}
      />

      <ContactForm
        initValues={contactData?.contact}
        onSubmit={submitContact}
        loading={updateContactLoading || insertContactLoading}
      />
    </>
  );
}

export default EditHospital;
